/* PDP KLOKI Star 2026 (šablona product.kloki-star-26) – převzato z _pdp-star-navrh/js/pdp-star.js.
   Texty z window.ps26T (sekce ps26-nakup). Původní komentář: chování nových prvků návrhu (galerie, barva, kód, lepicí lišta).
   Bez závislostí. Všechno je fail-open: bez JS je galerie posouvatelná řada,
   kód je čitelný text a lepicí lišta se prostě neukáže. */
(function () {
  var T = window.ps26T || {};
  'use strict';

  /* ---------- Galerie: počítadlo, šipky, tečky / náhledy ---------- */
  var gal = document.querySelector('[data-ps-gal]');
  if (gal) {
    var track = gal.querySelector('[data-ps-track]');
    var slides = Array.prototype.slice.call(track.children);
    var cislo = gal.querySelector('[data-ps-cislo]');
    var prev = gal.querySelector('[data-ps-prev]');
    var next = gal.querySelector('[data-ps-next]');
    var thumbs = gal.querySelector('[data-ps-thumbs]');
    var akt = 0;

    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Fotka ' + (i + 1) + ' z ' + slides.length);
      var img = s.querySelector('img');
      if (img) {
        var t = document.createElement('img');
        t.src = img.src.replace(/width=\d+/, 'width=160');
        t.alt = ''; t.loading = 'lazy';
        b.appendChild(t);
      }
      if (s.classList.contains('ps-gal__video')) { b.classList.add('is-video'); b.setAttribute('aria-label', 'Video ' + (i + 1) + ' z ' + slides.length); }
      b.addEventListener('click', function () { jdi(i); });
      thumbs.appendChild(b);
    });

    function jdi(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function obnov() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === akt && cislo.textContent) { /* nic */ }
      akt = i;
      cislo.textContent = String(i + 1);
      prev.disabled = i === 0;
      next.disabled = i === slides.length - 1;
      Array.prototype.forEach.call(thumbs.children, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      ukazNahled(i);
      slides.forEach(function (sl, j) { if (j !== i && sl.classList.contains('is-playing')) zastavVideo(sl); });
    }
    /* Video ve galerii: Wistia se načte až po klepnutí (do té doby jen obrázek), odjetím se zastaví */
    function pustVideo(sl) {
      if (sl.classList.contains('is-playing')) return;
      var vsrc = sl.getAttribute('data-video-src');
      if (vsrc) {
        /* Video z Files v jazyce stránky (metapole kloki.galerie_<jazyk>) */
        var v = document.createElement('video');
        v.src = vsrc; v.controls = true; v.autoplay = true; v.playsInline = true; v.className = 'ps-vid__frame';
        sl.appendChild(v); sl.classList.add('is-playing');
        v.play && v.play().catch(function () {});
        if (window.posthog && posthog.capture) posthog.capture('video_play', { video: vsrc.split('/').pop(), placement: 'gallery' });
        return;
      }
      var id = sl.getAttribute('data-wistia');
      var f = document.createElement('iframe');
      f.src = 'https://fast.wistia.net/embed/iframe/' + id + '?autoplay=1&playsinline=1&videoFoam=false';
      f.title = 'Video o KLOKI Star'; f.allow = 'autoplay; fullscreen'; f.setAttribute('allowfullscreen', '');
      f.className = 'ps-vid__frame';
      sl.appendChild(f); sl.classList.add('is-playing');
      if (window.posthog && posthog.capture) posthog.capture('video_play', { video: id, placement: 'gallery' });
    }
    function zastavVideo(sl) {
      var f = sl.querySelector('.ps-vid__frame');
      if (f) f.remove();
      sl.classList.remove('is-playing');
    }
    slides.forEach(function (sl) {
      var vb = sl.querySelector('.ps-vid');
      if (vb) vb.addEventListener('click', function () { pustVideo(sl); });
    });
    /* Náhledy: jedna posouvatelná řada; aktivní náhled se posune do pohledu (jen řada, ne stránka) */
    var tw = document.createElement('div');
    tw.className = 'ps-gal__thumbwrap';
    thumbs.parentNode.insertBefore(tw, thumbs);
    tw.appendChild(thumbs);
    thumbs.classList.add('ps-gal__thumbs');
    var tPrev = document.createElement('button'), tNext = document.createElement('button');
    [[tPrev, 'prev', T.nahledy_pred || '', -1], [tNext, 'next', T.nahledy_dal || '', 1]].forEach(function (a) {
      a[0].type = 'button'; a[0].className = 'ps-gal__tarrow ps-gal__tarrow--' + a[1];
      a[0].setAttribute('aria-label', a[2]); a[0].tabIndex = -1;
      a[0].innerHTML = '<svg aria-hidden="true"><use href="#i-chevron"/></svg>';
      a[0].addEventListener('click', function () { thumbs.scrollBy({ left: a[3] * thumbs.clientWidth * 0.8, behavior: 'smooth' }); });
      tw.appendChild(a[0]);
    });
    function tSipky() {
      tPrev.hidden = thumbs.scrollLeft < 4;
      tNext.hidden = thumbs.scrollLeft + thumbs.clientWidth > thumbs.scrollWidth - 4;
    }
    thumbs.addEventListener('scroll', function () { requestAnimationFrame(tSipky); }, { passive: true });
    window.addEventListener('resize', tSipky);
    function ukazNahled(i) {
      var b = thumbs.children[i];
      if (!b) return;
      var l = b.offsetLeft - thumbs.offsetLeft, r = l + b.offsetWidth;
      if (l < thumbs.scrollLeft + 4) thumbs.scrollTo({ left: Math.max(0, l - b.offsetWidth * 0.4), behavior: 'smooth' });
      else if (r > thumbs.scrollLeft + thumbs.clientWidth - 4) thumbs.scrollTo({ left: r - thumbs.clientWidth + b.offsetWidth * 0.4, behavior: 'smooth' });
      tSipky();
    }
    var ceka = false;
    track.addEventListener('scroll', function () {
      if (ceka) return; ceka = true;
      requestAnimationFrame(function () { ceka = false; obnov(); });
    }, { passive: true });
    prev.addEventListener('click', function () { jdi(akt - 1); });
    next.addEventListener('click', function () { jdi(akt + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); jdi(akt + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); jdi(akt - 1); }
    });
    obnov();
    window.psGalJdi = function (i) { track.scrollTo({ left: i * track.clientWidth }); };
  }

  /* ---------- Fotky přes celou obrazovku (klepnutí na fotku nebo lupu) ----------
     Posun prstem mezi fotkami, dvojklep / klik = přiblížení 2,5×, tah dolů / Esc / Zpět = zavřít. */
  if (gal && window.HTMLDialogElement) {
    var gTrack = gal.querySelector('[data-ps-track]');
    var gSlides = Array.prototype.slice.call(gTrack.children);
    var gImgs = [], lbZGal = [], galZLb = [];
    gSlides.forEach(function (sl, gi) {
      if (sl.classList.contains('ps-gal__video')) { galZLb[gi] = -1; return; }
      galZLb[gi] = gImgs.length; lbZGal.push(gi); gImgs.push(sl.querySelector('img'));
    });
    var naLb = function (gi) { var k = galZLb[gi]; if (k >= 0) return k; for (var x = gi + 1; x < galZLb.length; x++) if (galZLb[x] >= 0) return galZLb[x]; return 0; };
    var velka = function (src) { return src.replace(/width=\d+/, 'width=1600'); };
    var lb = document.createElement('dialog');
    lb.className = 'ps-lb';
    lb.setAttribute('aria-label', 'Fotky KLOKI Star');
    lb.innerHTML = '<div class="ps-lb__bar"><span class="ps-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="ps-lb__close" aria-label="' + (T.lb_zavrit || '') + '"><svg aria-hidden="true"><use href="#i-x"/></svg></button></div>' +
      '<div class="ps-lb__in" style="position:relative"><div class="ps-lb__track"></div>' +
      '<button type="button" class="ps-lb__arrow ps-lb__arrow--prev" aria-label="' + (T.foto_pred || '') + '"><svg aria-hidden="true"><use href="#i-chevron"/></svg></button>' +
      '<button type="button" class="ps-lb__arrow ps-lb__arrow--next" aria-label="' + (T.foto_dal || '') + '"><svg aria-hidden="true"><use href="#i-chevron"/></svg></button></div>' +
      '<div class="ps-lb__foot"><p class="ps-lb__hint">' + (T.lb_tip || '') + '</p><div class="ps-lb__thumbs"></div></div>';
    document.body.appendChild(lb);
    if (matchMedia('(hover: hover)').matches) lb.querySelector('.ps-lb__hint').textContent = (T.lb_tip_mys || '');
    var lbTrack = lb.querySelector('.ps-lb__track'), lbIn = lb.querySelector('.ps-lb__in');
    var lbCount = lb.querySelector('.ps-lb__count'), lbThumbs = lb.querySelector('.ps-lb__thumbs');
    var lbPrev = lb.querySelector('.ps-lb__arrow--prev'), lbNext = lb.querySelector('.ps-lb__arrow--next');
    var lbAkt = 0, lbHist = false, opener = null;
    gImgs.forEach(function (im, i) {
      var f = document.createElement('div'); f.className = 'ps-lb__slide';
      var x = document.createElement('img'); x.alt = im.alt; x.dataset.src = velka(im.src); x.decoding = 'async';
      f.appendChild(x); lbTrack.appendChild(f);
      var b = document.createElement('button'); b.type = 'button';
      b.setAttribute('aria-label', 'Fotka ' + (i + 1) + ' z ' + gImgs.length);
      b.innerHTML = '<img alt="" loading="lazy" src="' + im.src.replace(/width=\d+/, 'width=120') + '">';
      b.addEventListener('click', function () { lbJdi(i); });
      lbThumbs.appendChild(b);
    });
    var lbSlides = Array.prototype.slice.call(lbTrack.children);
    function nacti(i) {
      [i - 1, i, i + 1].forEach(function (k) { var s = lbSlides[k]; if (s) { var im = s.firstChild; if (!im.src) im.src = im.dataset.src; } });
    }
    function odzoom() { lb.classList.remove('is-zoom'); lbSlides.forEach(function (s) { s.classList.remove('is-zoom'); s.firstChild.style.width = ''; s.scrollTo(0, 0); }); }
    function lbJdi(i, hned) {
      i = Math.max(0, Math.min(lbSlides.length - 1, i));
      odzoom();
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: hned || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      lbStav(i);
    }
    function lbStav(i) {
      lbAkt = i; nacti(i);
      lbCount.textContent = (i + 1) + ' / ' + lbSlides.length;
      lbPrev.disabled = i === 0; lbNext.disabled = i === lbSlides.length - 1;
      Array.prototype.forEach.call(lbThumbs.children, function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
        if (j === i) lbThumbs.scrollTo({ left: b.offsetLeft - lbThumbs.clientWidth / 2 + b.offsetWidth / 2, behavior: 'smooth' });
      });
    }
    lbTrack.addEventListener('scroll', function () {
      if (lb.classList.contains('is-zoom')) return;
      requestAnimationFrame(function () {
        var i = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
        if (i !== lbAkt) lbStav(i);
      });
    }, { passive: true });
    function otevri(i, odkud) {
      opener = odkud || document.activeElement;
      document.documentElement.classList.add('ps-lb-open');
      lb.showModal();
      lbJdi(i, true);
      if (history.pushState) { history.pushState({ psLb: 1 }, ''); lbHist = true; }
    }
    function zavri(zHistorie) {
      if (!lb.open) return;
      odzoom();
      lb.close();
      lbIn.style.transform = ''; lbIn.style.opacity = '';
      document.documentElement.classList.remove('ps-lb-open');
      if (window.psGalJdi) window.psGalJdi(lbZGal[lbAkt]);
      if (lbHist && !zHistorie) { lbHist = false; history.back(); }
      lbHist = false;
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    window.addEventListener('popstate', function () { if (lb.open) { lbHist = false; zavri(true); } });
    lb.addEventListener('cancel', function (e) { e.preventDefault(); zavri(); });
    lb.querySelector('.ps-lb__close').addEventListener('click', function () { zavri(); });
    lbPrev.addEventListener('click', function () { lbJdi(lbAkt - 1); });
    lbNext.addEventListener('click', function () { lbJdi(lbAkt + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); lbJdi(lbAkt + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbJdi(lbAkt - 1); }
    });
    /* přiblížení: klik myší nebo dvojité klepnutí, na bod, kam se klepne */
    function zoom(slide, x, y) {
      if (slide.classList.contains('is-zoom')) { odzoom(); return; }
      var im = slide.firstChild, r = im.getBoundingClientRect();
      var px = (x - r.left) / r.width, py = (y - r.top) / r.height;
      im.style.width = Math.round(r.width * 2.5) + 'px';
      lb.classList.add('is-zoom'); slide.classList.add('is-zoom');
      requestAnimationFrame(function () {
        slide.scrollLeft = px * im.offsetWidth - slide.clientWidth / 2;
        slide.scrollTop = py * im.offsetHeight - slide.clientHeight / 2;
      });
    }
    var posledniTap = 0;
    lbSlides.forEach(function (s) {
      s.addEventListener('click', function (e) {
        if (e.target.tagName !== 'IMG') { if (!s.classList.contains('is-zoom')) zavri(); return; }
        if (matchMedia('(hover: hover)').matches) { zoom(s, e.clientX, e.clientY); return; }
        var t = Date.now();
        if (t - posledniTap < 320) { zoom(s, e.clientX, e.clientY); posledniTap = 0; } else { posledniTap = t; }
      });
    });
    /* tah dolů zavře (jen když není přiblíženo) */
    var y0 = null, x0 = 0;
    lbIn.addEventListener('touchstart', function (e) {
      if (lb.classList.contains('is-zoom') || e.touches.length > 1) { y0 = null; return; }
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX;
    }, { passive: true });
    lbIn.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      var dy = e.touches[0].clientY - y0, dx = Math.abs(e.touches[0].clientX - x0);
      if (dy > 10 && dy > dx * 1.5) { lbIn.style.transform = 'translateY(' + dy + 'px)'; lbIn.style.opacity = String(Math.max(.4, 1 - dy / 600)); }
    }, { passive: true });
    lbIn.addEventListener('touchend', function () {
      if (y0 === null) return;
      var m = /translateY\(([\d.]+)px/.exec(lbIn.style.transform || '');
      y0 = null;
      if (m && +m[1] > 110) zavri(); else { lbIn.style.transform = ''; lbIn.style.opacity = ''; }
    });
    /* otevření: klepnutí na fotku v galerii, lupa, Enter na galerii */
    gImgs.forEach(function (im, i) { im.addEventListener('click', function () { otevri(i, gTrack); }); });
    var lupa = document.createElement('button');
    lupa.type = 'button'; lupa.className = 'ps-gal__zoom'; lupa.setAttribute('aria-label', (T.lupa || ''));
    lupa.innerHTML = '<svg aria-hidden="true"><use href="#i-search"/></svg>';
    lupa.addEventListener('click', function () { otevri(naLb(Math.round(gTrack.scrollLeft / Math.max(1, gTrack.clientWidth))), lupa); });
    gal.appendChild(lupa);
    gTrack.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); otevri(naLb(Math.round(gTrack.scrollLeft / Math.max(1, gTrack.clientWidth))), gTrack); }
    });
  }


  /* ---------- Navigace po stránce: připnutí pod hlavičku, aktivní záložka podle polohy ---------- */
  var tabs = document.querySelector('[data-ps-tabs]');
  if (tabs) {
    var tWrap = tabs.parentNode;
    /* Lepení (position: sticky) funguje jen v rámci rodiče. Shopify obaluje sekci vlastním divem,
       takže by navigace držela jen do konce nákupní sekce. Vyndáme ji přímo do main za sekci. */
    var tSek = tWrap.closest('.shopify-section');
    if (tSek && tSek.parentNode) tSek.parentNode.insertBefore(tWrap, tSek.nextSibling);
    var tList = tabs.querySelector('.ps-tabs__list');
    var tLinks = Array.prototype.slice.call(tabs.querySelectorAll('.ps-tabs__a'));
    var tCile = tLinks.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var tAkt = -1, tCeka = false;
    function hlavicka() {
      var h = document.querySelector('.hp-nav');
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return (r.bottom <= 0 || r.top > 2) ? 0 : Math.round(r.bottom);
    }
    function tObnov() {
      tCeka = false;
      var top = hlavicka();
      document.documentElement.style.setProperty('--ps-tabs-top', top + 'px');
      /* Spodní hrana navigace: pod ní se lepí hlavička srovnávací tabulky (ps26.css) */
      document.documentElement.style.setProperty('--ps-tabs-bot', (top + tabs.offsetHeight) + 'px');
      tabs.classList.toggle('is-stuck', tWrap.getBoundingClientRect().top <= top + 1);
      var hranice = top + tabs.offsetHeight + 90, i = -1;
      tCile.forEach(function (t, j) { if (t && t.getBoundingClientRect().top <= hranice) i = j; });
      if (i === tAkt) return;
      tAkt = i;
      tLinks.forEach(function (a, j) {
        a.classList.toggle('is-active', j === i);
        if (j === i) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
      var a = tLinks[i];
      if (a) {
        var l = a.offsetLeft - tList.offsetLeft;
        if (l < tList.scrollLeft || l + a.offsetWidth > tList.scrollLeft + tList.clientWidth) {
          tList.scrollTo({ left: Math.max(0, l - 24), behavior: 'smooth' });
        }
      }
    }
    /* Telefon: šipka „další záložky“ a jedno pošťouchnutí řady, ať je vidět, že se dá posouvat */
    var more = document.createElement('button');
    more.type = 'button'; more.className = 'ps-tabs__more'; more.setAttribute('aria-label', (T.tabs_dalsi || ''));
    more.innerHTML = '<span><svg aria-hidden="true"><use href="#i-chevron"/></svg></span>';
    tabs.querySelector('.ps-tabs__in').appendChild(more);
    more.addEventListener('click', function () { tList.scrollBy({ left: tList.clientWidth * 0.6, behavior: 'smooth' }); });
    function moreStav() { more.hidden = tList.scrollLeft + tList.clientWidth >= tList.scrollWidth - 4; }
    tList.addEventListener('scroll', function () { requestAnimationFrame(moreStav); }, { passive: true });
    window.addEventListener('resize', moreStav);
    moreStav();
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var nudge = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        nudge.disconnect();
        if (tList.scrollWidth <= tList.clientWidth + 4 || tList.scrollLeft > 0) return;
        setTimeout(function () {
          tList.scrollTo({ left: 64, behavior: 'smooth' });
          setTimeout(function () { if (tList.scrollLeft <= 70) tList.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
        }, 350);
      }, { threshold: 1 });
      nudge.observe(tabs);
    }
    window.addEventListener('scroll', function () { if (!tCeka) { tCeka = true; requestAnimationFrame(tObnov); } }, { passive: true });
    window.addEventListener('resize', tObnov);
    tLinks.forEach(function (a, j) {
      a.addEventListener('click', function (e) {
        var t = tCile[j];
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.scrollY - (hlavicka() + tabs.offsetHeight + 12);
        window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + t.id);
      });
    });
    tObnov();
  }


  /* ---------- Porovnání Star × Moon v okně; Zpět a Esc zavřou ---------- */
  var cmp = document.getElementById('porovnani');
  var cmpOpen = document.querySelector('[data-ps-cmp-open]');
  if (cmp && cmpOpen && cmp.showModal) {
    var cmpHist = false;
    var cmpZavri = function (zHist, potom) {
      if (!cmp.open) return;
      cmp.close();
      document.documentElement.classList.remove('ps-cmp-lock');
      if (cmpHist && !zHist) { cmpHist = false; history.back(); }
      cmpHist = false;
      if (potom) potom(); else cmpOpen.focus({ preventScroll: true });
    };
    cmpOpen.addEventListener('click', function () {
      document.documentElement.classList.add('ps-cmp-lock');
      cmp.showModal();
      cmp.scrollTop = 0;
      if (history.pushState) { history.pushState({ psCmp: 1 }, ''); cmpHist = true; }
    });
    cmp.addEventListener('cancel', function (e) { e.preventDefault(); cmpZavri(); });
    cmp.addEventListener('click', function (e) {
      if (e.target === cmp) { cmpZavri(); return; }
      var z = e.target.closest('[data-ps-cmp-close]');
      if (!z) return;
      if (z.tagName === 'A') {
        e.preventDefault();
        cmpZavri(false, function () { setTimeout(function () { var k = document.querySelector('.ps-cta') || document.getElementById('koupit'); if (k) { k.scrollIntoView({ behavior: 'smooth', block: 'center' }); k.focus({ preventScroll: true }); } }, 80); });
      } else cmpZavri();
    });
    window.addEventListener('popstate', function () { if (cmp.open) cmpZavri(true); });
  }

  /* ---------- Barva: v theme odkazy na produkty barev (sekce ps26-nakup), JS nic nedělá ---------- */

  /* ---------- Kód akce: kopírování + potvrzení ---------- */
  var kodBtn = document.querySelector('[data-ps-kod]');
  if (kodBtn) {
    var stav = document.getElementById('ps-kod-stav');
    var label = kodBtn.querySelector('[data-ps-kod-label]');
    kodBtn.addEventListener('click', function () {
      var kod = kodBtn.getAttribute('data-ps-kod');
      var hotovo = function () {
        kodBtn.classList.add('is-copied');
        label.textContent = T.zkopirovano || '';
        stav.textContent = (T.kod_stav || '').replace('@KOD@', kod);
        clearTimeout(kodBtn._t);
        kodBtn._t = setTimeout(function () { kodBtn.classList.remove('is-copied'); label.textContent = T.kopirovat || ''; stav.textContent = ''; }, 4000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(kod).then(hotovo, hotovo);
      else hotovo();
    });
  }

  /* ---------- Hlavní tlačítko: hodinky + dárky do košíku (stejně jako blok grand_slam_offer v main-product) ---------- */
  var cta = document.querySelector('[data-ps-cta]');
  if (cta) {
    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      var txt = cta.querySelector('[data-ps-cta-txt]'), puvodni = txt.textContent;
      cta.disabled = true; txt.textContent = cta.getAttribute('data-ps-pridavam') || puvodni;
      var mainId = parseInt(cta.getAttribute('data-varianta'), 10);
      var mainItem = { id: mainId, quantity: 1 };
      var gifts = [];
      document.querySelectorAll('.ps-buy [data-ps-dar]').forEach(function (el) {
        if (el.type === 'checkbox' && !el.checked) return;
        var vid = parseInt(el.getAttribute('data-variant-id'), 10);
        if (vid) gifts.push({ id: vid, choice: el.getAttribute('data-volba') === '1' });
      });
      var add = (window.KlokiGifts && typeof window.KlokiGifts.addWithGifts === 'function')
        ? window.KlokiGifts.addWithGifts(mainItem, gifts)
        : fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: gifts.map(function (g) { return { id: g.id, quantity: 1 }; }).concat([mainItem]) })
          }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'cart'); return d; }); });
      add.then(function () {
        try { if (window.posthog && posthog.capture) posthog.capture('add_to_cart', { variant_id: String(mainId), quantity: 1, placement: 'pdp_star_26' }); } catch (e) {}
        if (window.KlokiCareUpsell && typeof window.KlokiCareUpsell.afterCartAdd === 'function') {
          return window.KlokiCareUpsell.afterCartAdd({ source: 'ps26', upsellEligible: true, triggerVariantId: mainId });
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.KlokiCart) window.KlokiCart.open();
      }).catch(function () {
        alert(cta.getAttribute('data-ps-chyba') || '');
      }).finally(function () { cta.disabled = false; txt.textContent = puvodni; });
    });
  }

  /* ---------- Lepicí lišta na mobilu: až když hlavní tlačítko odjede NAD obrazovku (jako dnešní PDP),
     dokud je pod obrazovkou nebo vidět, lišta se neukazuje. U patičky zmizí. ---------- */
  var sticky = document.querySelector('[data-ps-sticky]');
  if (sticky && cta && 'IntersectionObserver' in window) {
    var btn = sticky.querySelector('a');
    var paticka = document.querySelector('.kl-paticka, footer');
    var ctaPrejeto = false, patickaVidet = false;
    var prepni = function () {
      var on = ctaPrejeto && !patickaVidet;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (e) {
      ctaPrejeto = !e[0].isIntersecting && e[0].boundingClientRect.bottom < 0;
      prepni();
    }).observe(cta);
    if (paticka) new IntersectionObserver(function (e) { patickaVidet = e[0].isIntersecting; prepni(); }).observe(paticka);
  }

  /* ---------- „Do košíku“ v lepicích lištách = totéž jako hlavní tlačítko (hodinky + vybrané dárky) ---------- */
  if (cta) {
    document.querySelectorAll('.ps-sticky__btn, .ps-tabs__cta').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (cta.disabled) return;
        e.preventDefault();
        cta.click();
      });
    });
  }
})();

/* KLOKI Security: živá ústředna. Bez JS zůstane statické schéma, tady se jen rozehraje. */
(function () {
  var box = document.querySelector('[data-sc]');
  if (!box) return;
  var st = box.querySelector('.ps-sec__st');
  var svg = box.querySelector('.ps-sec__dr');
  var l0 = box.querySelector('.ps-sec__l--0');
  var l1 = box.querySelector('.ps-sec__l--1');
  var tecka = box.querySelector('.ps-sec__t');
  var btn = [].slice.call(box.querySelectorAll('.ps-sec__v'));
  var stit = box.querySelector('.ps-sec__stit');
  var hod = box.querySelector('.ps-sec__hod');
  var jm = box.querySelector('[data-sc-jm]');
  var stav = box.querySelector('.ps-sec__stav');
  var klid = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var beh = 0, akt = 0, auto = !klid, casovac = 0, vidim = false;
  var PORADI = [0, 2, 1, 3];

  function bod(el, kde) {
    var o = st.getBoundingClientRect(), r = el.getBoundingClientRect();
    return kde === 'p' ? [r.right - o.left, r.top + r.height / 2 - o.top]
      : kde === 'l' ? [r.left - o.left, r.top + r.height / 2 - o.top]
      : kde === 'd' ? [r.left + r.width / 2 - o.left, r.bottom - o.top]
      : [r.left + r.width / 2 - o.left, r.top - o.top];
  }
  function krivka(a, b, svisle) {
    return svisle
      ? 'M' + a + 'C' + a[0] + ' ' + (a[1] + b[1]) / 2 + ' ' + b[0] + ' ' + (a[1] + b[1]) / 2 + ' ' + b
      : 'M' + a + 'C' + (a[0] + b[0]) / 2 + ' ' + a[1] + ' ' + (a[0] + b[0]) / 2 + ' ' + b[1] + ' ' + b;
  }
  function kresli() {
    var sv = window.matchMedia('(max-width:989px)').matches;
    var u = box.querySelector('.ps-sec__stit');
    var h = box.querySelector('.ps-sec__w');
    var t = btn[akt];
    /* na telefonu jde spojnice od spodku celé skupiny tlačítek, jinak by vedla přes ně */
    l0.setAttribute('d', sv ? krivka(bod(box.querySelector('.ps-sec__vol'), 'd'), bod(u, 'h'), true) : krivka(bod(t, 'p'), bod(u, 'l'), false));
    l1.setAttribute('d', sv ? krivka(bod(u, 'd'), bod(h, 'h'), true) : krivka(bod(u, 'p'), bod(h, 'l'), false));
  }
  function jed(cesta, barva, ms, hotovo, id) {
    if (klid) { hotovo(); return; }
    var del = cesta.getTotalLength(), t0 = 0;
    tecka.style.fill = barva; tecka.style.color = barva; tecka.style.opacity = 1;
    cesta.style.stroke = barva;
    cesta.style.strokeDasharray = del + ' ' + del;
    function krok(t) {
      if (id !== beh) return;
      t0 = t0 || t;
      var p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 2.4);
      var q = cesta.getPointAtLength(del * e);
      tecka.setAttribute('cx', q.x); tecka.setAttribute('cy', q.y);
      cesta.style.strokeDashoffset = del * (1 - e);
      if (p < 1) requestAnimationFrame(krok); else { tecka.style.opacity = 0; hotovo(); }
    }
    requestAnimationFrame(krok);
  }
  function spust(i) {
    var id = ++beh, t = btn[i], ok = t.getAttribute('data-ok') === '1', j = t.getAttribute('data-jm');
    var barva = ok ? '#35E0A8' : '#FF6B86';
    akt = i;
    btn.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    stit.classList.remove('is-ok', 'is-ne');
    hod.classList.remove('is-zvoni');
    stav.classList.toggle('is-ne', !ok);
    [l0, l1].forEach(function (l) { l.style.stroke = ''; l.style.strokeDasharray = ''; l.style.strokeDashoffset = ''; });
    kresli();
    jed(l0, barva, 620, function () {
      if (id !== beh) return;
      void stit.offsetWidth;
      if (!ok) {
        stit.classList.add('is-ne');
        stav.innerHTML = (window.ps26S && ps26S.ne || '').replace('@KDO@', j);
        return;
      }
      stit.classList.add('is-ok');
      jed(l1, barva, 460, function () {
        if (id !== beh) return;
        jm.textContent = j;
        hod.classList.add('is-zvoni');
        stav.innerHTML = (window.ps26S && ps26S.ano || '').replace('@KDO@', j);
      }, id);
    }, id);
  }
  function dalsi() {
    clearTimeout(casovac);
    if (!auto || !vidim || document.hidden) return;
    casovac = setTimeout(function () {
      if (!auto || !vidim) return;
      spust(PORADI[(PORADI.indexOf(akt) + 1) % PORADI.length]);
      dalsi();
    }, 3800);
  }
  btn.forEach(function (b, i) {
    b.addEventListener('click', function () { auto = false; clearTimeout(casovac); spust(i); });
  });
  window.addEventListener('resize', kresli);
  window.addEventListener('load', kresli);
  kresli();
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      vidim = e[0].isIntersecting;
      if (vidim && auto) { spust(akt); dalsi(); } else clearTimeout(casovac);
    }, { threshold: .35 }).observe(st);
  }
})();

/* Odkazy sekcí Moonu na nabídku (#gs-offer, 4. 11. 2026): nativní skok z konce stránky nahoru
   přistával pokaždé jinde (nad cílem se ještě dotahují obrázky a stránka se posune), takže cena
   občas skončila pod hlavičkou. Skok míří na cenu a po doběhnutí se jednou dorovná. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#gs-offer"]');
    if (!a) return;
    var kotva = document.getElementById('gs-offer');
    var cil = document.querySelector('.ps-buy .ps-price') || kotva;
    if (!cil) return;
    e.preventDefault();
    var okraj = function () { return (parseFloat(getComputedStyle(kotva || cil).scrollMarginTop) || 100) + 8; };
    var jed = function (jak) { window.scrollTo({ top: cil.getBoundingClientRect().top + window.scrollY - okraj(), behavior: jak }); };
    jed(matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
    [700, 1400].forEach(function (ms) {
      setTimeout(function () { if (Math.abs(cil.getBoundingClientRect().top - okraj()) > 24) jed('auto'); }, ms);
    });
    try { history.replaceState(null, '', '#gs-offer'); } catch (x) {}
  });
})();
